<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-row"></div>
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full"  />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Currency</label>
              <v-select :clearable="true" name="currency" placeholder=""
                        label="name" v-model="filters['currency']" :reduce="option => option.code"
                        :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Customer Account Status</label>
              <v-select :clearable="true" name="status" placeholder="" v-model="filters['status']" :options="statusList"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Account Type</label>
              <v-select :clearable="true" name="account-type" placeholder="" v-model="filters['account-type']" 
              :options="['credit', 'proforma']"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Account Handler</label>
              <v-select name="account_handlers" :closeOnSelect="false" :clearable="false"
                v-model="filters['account-handler']" :options="account_handlers" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="CUSTOMERS" v-can:any="['create-edit-customer', 'view-customer', 'sales-crm-access']">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'approved-customers-report'" :filters="filters" :button_label="'Export approved customer list'"/>
              <excel-download :name="'customer-all-data-sheet'" :button_label="'Export all data'"/>
              <excel-download :name="'customer-sheet'" :filters="filters" :button_label="'Export customer profiles only'"/>
              <excel-download :name="'customer-users-sheet'" :button_label="'Export customer end user data only'"/>
              <vs-button v-can:any="['bulk-update-customer-account-handler']" @click="onClickCustomerBulkAction" class="mr-4" color="primary" type="filled">Bulk apply</vs-button>
              <vs-button v-can:any="['create-edit-customer', 'sales-crm-access']" @click="onClickCreateCustomer" class="mr-4" color="primary" type="filled">Create customer</vs-button>
            </div>
           </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="customers-table" v-can:any="['view-customer', 'sales-crm-access']" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"  sort @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="13%" sort-key="account_number">ACCOUNT NUMBER</vs-th>
                <vs-th width="14%" sort-key="company_name">COMPANY NAME</vs-th>
                <vs-th width="13%">EMAIL</vs-th>
                <vs-th width="10%">MAIN TELEPHONE</vs-th>
                <vs-th width="5%" sort-key="currency">CURRENCY</vs-th>
                <vs-th width="10%">ACCOUNT HANDLER</vs-th>
                <vs-th width="10%" sort-key="status">CUSTOMER ACCOUNT STATUS</vs-th>
                <vs-th width="9%">CUSTOMER PORTAL STATUS</vs-th>
                <vs-th width="8%">OTIF TRACKED</vs-th>
                <vs-th width="8%" v-can:any="['view-customer', 'sales-crm-access']">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" @click.native="onClickSupplierView(data[indextr].id)"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].account_number">
                    {{ data[indextr].account_number }}
                  </vs-td>

                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name }}
                  </vs-td>

                  <vs-td class="break-all" :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>
                  <vs-td :data="data[indextr].main_telephone">
                    {{ data[indextr].country_code_main_telephone }} {{ data[indextr].main_telephone }}
                  </vs-td>

                  <vs-td :data="data[indextr].account_currency">
                    <vs-chip style="border-radius: 0" size="small" class="ml-2" transparent color="#7952B3">
                      {{data[indextr].account_currency}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].account_handler || 'UNALLOCATED' }}
                  </vs-td>

                  <vs-td :data="data[indextr].status_id">
                    <vs-chip transparent :color="customerStatusColorFactory(data[indextr].status_id)">
                      {{ data[indextr].status.name || N/A}}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].is_customer_activated">
                    <vs-chip transparent :color="data[indextr].is_customer_activated ? 'success' : 'danger'">
                      {{ data[indextr].is_customer_activated ? 'Activated' : 'Suspended' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].is_otif_tracked">
                    <vs-chip transparent :color="data[indextr].is_otif_tracked ? 'success' : 'danger'">
                      {{ data[indextr].is_otif_tracked ? 'Yes' : 'No' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td v-can:any="['view-customer', 'sales-crm-access']">
                    <div class="vx-row flex items-center">
<!--                      <vx-tooltip text="View" position="left">-->
<!--                        <vs-button @click="onClickSupplierUpdate(data[indextr].id)"-->
<!--                                   radius color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>-->
<!--                      </vx-tooltip>-->
                      <vx-tooltip text="View/Update customer" position="left">
                        <vs-button class="ml-3" @click.stop="onClickSupplierView(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Customer Activity Logs" position="left">
                        <vs-button class="ml-2" @click.stop="onClickViewCustomerLogs(data[indextr].id, data[indextr].company_name)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-list"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"
              class="p-5"
              v-can:any="['view-customer', 'sales-crm-access']">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-pop-up ref="createCustomerPopUp"/>
    <update-supplier-pop-up ref="updateSupplierPopUp"/>
    <view-supplier-pop-up ref="viewSupplierPopUp"/>
    <view-customer-log-pop-up ref="viewCustomerLogPopUp"/>
    <customer-bulk-action-pop-up ref="customerBulkActionPopUp" @refreshData="refreshData"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import ErrorMessages from '@/mixins/ErrorMessages'
  const StaffRepository = RepositoryFactory.get('staff')
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerPopUp from '@/components/popups/customer/CreateCustomerPopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  import ViewCustomerLogPopUp from '@/components/popups/customer/ViewCustomerLogPopUp'
  import CustomerBulkActionPopUp from '@/components/popups/customer/CustomerBulkActionPopUp'
  import {defaultPagination, perPageList} from "@/constants/config";
  import { mapGetters, mapActions } from 'vuex';
  import Utils from '@/mixins/Utils'


  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        currencies: [],
        statusList:[
          'Approved',
          'Rejected',
          'On Hold',
          'Pending Customer',
          'Subscriber',
          'Lead',
          'Pending Verification',
          'Opportunity',
        ],
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerPopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp,
      ViewCustomerLogPopUp,
      CustomerBulkActionPopUp,
    },
    mixins : [Filter, ErrorMessages,Utils],
    async mounted () {
      this.setFilterId('customer_list_filters',['search','currency','status', 'account-type', 'account-handler'])
      await this.fetchCurrencies()
      await this.fetchAccountHandlers()
      this.account_handlers.unshift({
        name:'Unallocated',
        value: 'unallocated'
      })
    },
    computed: {
      ...mapGetters(['account_handlers'])
    },
    methods: {
      ...mapActions(['fetchAccountHandlers']),
      async refreshData () {
        this.fetchCustomerList()
      },

      async fetchCustomerList() {
        await this.$vs.loading({
          container: '#customers-table',
          scale: 0.45
        })
        try { 
          const {data} = await CustomerRepository.get(this.page, this.filterQuery, this.perPage, this.sort)
          this.staff =  data.data
          this.meta = data.meta
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customers-table > .con-vs-loading')
      },
      async fetchCurrencies() {
        this.$vs.loading()
        const {data} =  (await StaffRepository.getCurrencyList()).data
        this.currencies = data
        this.$vs.loading.close()
      },
      onClickCustomerBulkAction(){
        this.$refs.customerBulkActionPopUp.openPopup(this.staff)
      },
      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      async onClickCreateCustomer () {
        await this.$refs.createCustomerPopUp.openPopup()
      },
      async onClickSupplierUpdate (id) {
        await this.$refs.updateSupplierPopUp.openPopup(id)
      },
      async onClickSupplierView (id) {
        // await this.$refs.viewSupplierPopUp.openPopup(id)
        this.$router.push({path: `/pages/manage-nimble/customers/${id}`})
      },
      async onClickViewCustomerLogs(id, companyName) {
        await this.$refs.viewCustomerLogPopUp.openPopup(id, companyName)
      },
      filterQueryUpdate (){
        this.fetchCustomerList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchCustomerList()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchCustomerList()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },

    },
    watch : {
      page(){
        this.fetchCustomerList()
      },
      perPage() {
        this.fetchCustomerList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }

  .unallocated-switch {
    margin-top: inherit;
  }
</style>
